
import { useToast } from "@/hooks/use-toast"
import {
  Notification,
  NotificationTitle,
  NotificationDescription,
} from "@/components/ui/notification"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} {...props} variant={variant as any}>
            <Notification 
              variant={variant as "default" | "success" | "error" | "warning" | "info"}
              onClose={() => props.onOpenChange?.(false)}
            >
              <div className="grid gap-1">
                {title && <NotificationTitle>{title}</NotificationTitle>}
                {description && (
                  <NotificationDescription>{description}</NotificationDescription>
                )}
              </div>
              {action}
            </Notification>
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
